export enum TargetingSearchPendoEventEnum {
    RUN = 'TARGETING_SEARCH_RUN',
    SAVE = 'TARGETING_SEARCH_SAVE',
}

